import axios from 'axios';
import { API_BASE_URL } from './maps';

const api = axios.create({ baseURL: `${API_BASE_URL}/api/v1`, timeout: 20000 });

export const createOneWayQuote = async ({ origin, destination, vehicleId, travelDate, pickupTime }) => {
  const { data } = await api.post('/quotes/one-way', {
    origin, destination, vehicleId, travelDate, pickupTime
  });
  return data;
};
